var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"d-flex align-self-center justify-content-center",attrs:{"content":_vm.text,"tabindex":"-1"}},[_c('img',{attrs:{"src":require("@/assets/svg/help.svg"),"alt":"Help Icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }